export default __webpack_public_path__ + "static/media/FrederiqueTarot-carre.bb61db90.jpg";